var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.permissionsArray.includes("manage_customers")
    ? _c(
        "div",
        {
          staticClass: "admin-content-area dashboard",
          attrs: { id: "page-content-wrapper" }
        },
        [
          _c("div", { staticClass: "container-fluid xyz location-listing" }, [
            _c(
              "div",
              {
                staticClass: "page-header-top-container",
                staticStyle: { position: "fixed" }
              },
              [
                _c("div", { staticClass: "page-name" }, [_vm._v("Customers")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row", staticStyle: { clear: "both" } },
                  [
                    _c("div", { staticClass: "col-md-3 forms-block" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {},
                        [
                          _c("v-select", {
                            staticStyle: { width: "100%", background: "#fff" },
                            attrs: {
                              name: "statusId",
                              id: "statusId",
                              label: "text",
                              searchable: false,
                              filterable: false,
                              options: _vm.statusArr,
                              clearable: false,
                              placeholder: "Select Status"
                            },
                            on: {
                              input: function($event) {
                                return _vm.onChnageStatus()
                              }
                            },
                            model: {
                              value: _vm.statusId,
                              callback: function($$v) {
                                _vm.statusId = $$v
                              },
                              expression: "statusId"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-9 forms-block" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary waves-effect pull-right mt-4",
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.addCustomer()
                            }
                          }
                        },
                        [_vm._v("Add")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary waves-effect pull-right mt-4",
                          attrs: { type: "submit" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.loadCustomer(true)
                            }
                          }
                        },
                        [_vm._v("Export")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "extraFeature btn btn-primary waves-effect pull-right ml-2 mt-4",
                          attrs: {
                            type: "submit",
                            id: "refreshList",
                            title: "Refresh"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.loadCustomer(false)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-rotate-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "admin-page-content",
                staticStyle: { "padding-top": "150px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "app-filter-good-table-container" },
                  [
                    _c("vue-good-table", {
                      ref: "listCustomer",
                      attrs: {
                        mode: "remote",
                        title: "Customer",
                        totalRows: _vm.totalRecords,
                        columns: _vm.columns,
                        rows: _vm.rows,
                        selectOptions: {
                          enabled: true,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: "custom-class",
                          selectionText: "rows selected",
                          clearSelectionText: "clear"
                        },
                        "pagination-options": {
                          enabled: true,
                          mode: "pages",
                          pageLabel: "Page",
                          position: "both",
                          perPage: _vm.serverParams.perPage,
                          setCurrentPage: _vm.serverParams.setCurrentPage,
                          perPageDropdown: [25, 50, 100, 200, 500],
                          dropdownAllowAll: false
                        },
                        "search-options": {
                          enabled: false
                        }
                      },
                      on: {
                        "on-page-change": _vm.onPageChange,
                        "on-column-filter": _vm.onColumnFilter,
                        "on-per-page-change": _vm.onPerPageChange,
                        "on-sort-change": _vm.onSortChange,
                        "on-selected-rows-change": _vm.selectionChanged
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "pagination-top",
                            fn: function(props) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vgt-wrap__footer top-pagination crm"
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-2 PerPage"
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              title: "Select Per Page",
                                              name: "customPerPage",
                                              id: "customPerPage",
                                              label: "text",
                                              clearable: false,
                                              searchable: false,
                                              filterable: false,
                                              options:
                                                _vm.serverParams
                                                  .perPageDropdown,
                                              placeholder: "Select Per Page"
                                            },
                                            on: {
                                              change: _vm.changedValueTask,
                                              input: function($event) {
                                                return _vm.changedValueTaskCustomPerPageTask()
                                              }
                                            },
                                            model: {
                                              value: _vm.serverParams.perPage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.serverParams,
                                                  "perPage",
                                                  $$v
                                                )
                                              },
                                              expression: "serverParams.perPage"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageRowCount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.paginationDisplayRowsTask
                                                ) +
                                                  " of " +
                                                  _vm._s(_vm.totalRecords)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-6 Pagination"
                                        },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "pagination" },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "FirstPage",
                                                  attrs: { title: "First Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPerticularPageClickTask(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item PreviousPage",
                                                  attrs: {
                                                    title: "Previous Page"
                                                  }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) - 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _vm.pageNumberListTask() <
                                              _vm.displayPageTask
                                                ? [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return [
                                                          n ==
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item active",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onPerticularPageClickTask(
                                                                        n
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) <= _vm.pageCompareTask
                                                      ? [
                                                          _vm._l(
                                                            _vm.displayPageTask,
                                                            function(n, index) {
                                                              return [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                            " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                        "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                            " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                        "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : Number(
                                                          _vm.serverParams.page
                                                        ) >=
                                                        _vm.pageNumberListTask() -
                                                          (_vm.pageCompareTask -
                                                            1)
                                                      ? [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return [
                                                                n >
                                                                _vm.pageNumberListTask() -
                                                                  _vm.displayPageTask
                                                                  ? [
                                                                      n ==
                                                                      Number(
                                                                        _vm
                                                                          .serverParams
                                                                          .page
                                                                      )
                                                                        ? _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item active",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                            "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onPerticularPageClickTask(
                                                                                    n
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                            "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return n >=
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                ) -
                                                                  (_vm.pageCompareTask -
                                                                    1) &&
                                                                n <=
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) +
                                                                    (_vm.pageCompareTask -
                                                                      1)
                                                                ? [
                                                                    n ==
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    )
                                                                      ? _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item active",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                            " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                        "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.onPerticularPageClickTask(
                                                                                  n
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                            " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                        "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                : _vm._e()
                                                            }
                                                          )
                                                        ]
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item NextPage",
                                                  attrs: { title: "Next Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) + 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "LastPage",
                                                  attrs: { title: "Last Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageJumpLabel" },
                                            [_vm._v("Page : ")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.jumpToPageTask,
                                                expression: "jumpToPageTask"
                                              }
                                            ],
                                            staticClass:
                                              "form-control form-control-sm",
                                            attrs: {
                                              type: "text",
                                              name: "jumpToPageTask",
                                              id: "jumpToPageTask",
                                              placeholder: "Page"
                                            },
                                            domProps: {
                                              value: _vm.jumpToPageTask
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.jumpToPageInTask.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.jumpToPageTask =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "pagination-bottom",
                            fn: function(props) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "vgt-wrap__footer crm" },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-2 PerPage"
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              title: "Select Per Page",
                                              name: "customPerPage",
                                              id: "customPerPage",
                                              label: "text",
                                              clearable: false,
                                              searchable: false,
                                              filterable: false,
                                              options:
                                                _vm.serverParams
                                                  .perPageDropdown,
                                              placeholder: "Select Per Page"
                                            },
                                            on: {
                                              change: _vm.changedValueTask,
                                              input: function($event) {
                                                return _vm.changedValueTaskCustomPerPageTask()
                                              }
                                            },
                                            model: {
                                              value: _vm.serverParams.perPage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.serverParams,
                                                  "perPage",
                                                  $$v
                                                )
                                              },
                                              expression: "serverParams.perPage"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageRowCount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.paginationDisplayRowsTask
                                                ) +
                                                  " of " +
                                                  _vm._s(_vm.totalRecords)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-sm-12 col-md-6 Pagination"
                                        },
                                        [
                                          _c(
                                            "ul",
                                            { staticClass: "pagination" },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "FirstPage",
                                                  attrs: { title: "First Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.onPerticularPageClickTask(
                                                                  1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("1")]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item PreviousPage",
                                                  attrs: {
                                                    title: "Previous Page"
                                                  }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == 1
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) - 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-left"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _vm.pageNumberListTask() <
                                              _vm.displayPageTask
                                                ? [
                                                    _vm._l(
                                                      _vm.pageNumberListTask(),
                                                      function(n, index) {
                                                        return [
                                                          n ==
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          )
                                                            ? _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item active",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "li",
                                                                {
                                                                  staticClass:
                                                                    "PagesClass page-item",
                                                                  attrs: {
                                                                    title:
                                                                      "Page " +
                                                                      n,
                                                                    id:
                                                                      "pageNumber" +
                                                                      n
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onPerticularPageClickTask(
                                                                        n
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      staticClass:
                                                                        "page-link",
                                                                      attrs: {
                                                                        href:
                                                                          "javascript:void(0)"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        " +
                                                                          _vm._s(
                                                                            n
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                        ]
                                                      }
                                                    )
                                                  ]
                                                : [
                                                    Number(
                                                      _vm.serverParams.page
                                                    ) <= _vm.pageCompareTask
                                                      ? [
                                                          _vm._l(
                                                            _vm.displayPageTask,
                                                            function(n, index) {
                                                              return [
                                                                n ==
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                )
                                                                  ? _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item active",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                            " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                        "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "PagesClass page-item",
                                                                        attrs: {
                                                                          title:
                                                                            "Page " +
                                                                            n,
                                                                          id:
                                                                            "pageNumber" +
                                                                            n
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.onPerticularPageClickTask(
                                                                              n
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "page-link",
                                                                            attrs: {
                                                                              href:
                                                                                "javascript:void(0)"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                            " +
                                                                                _vm._s(
                                                                                  n
                                                                                ) +
                                                                                "\n                                                        "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : Number(
                                                          _vm.serverParams.page
                                                        ) >=
                                                        _vm.pageNumberListTask() -
                                                          (_vm.pageCompareTask -
                                                            1)
                                                      ? [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return [
                                                                n >
                                                                _vm.pageNumberListTask() -
                                                                  _vm.displayPageTask
                                                                  ? [
                                                                      n ==
                                                                      Number(
                                                                        _vm
                                                                          .serverParams
                                                                          .page
                                                                      )
                                                                        ? _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item active",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                            "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "li",
                                                                            {
                                                                              staticClass:
                                                                                "PagesClass page-item",
                                                                              attrs: {
                                                                                title:
                                                                                  "Page " +
                                                                                  n,
                                                                                id:
                                                                                  "pageNumber" +
                                                                                  n
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.onPerticularPageClickTask(
                                                                                    n
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  staticClass:
                                                                                    "page-link",
                                                                                  attrs: {
                                                                                    href:
                                                                                      "javascript:void(0)"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                                                                " +
                                                                                      _vm._s(
                                                                                        n
                                                                                      ) +
                                                                                      "\n                                                            "
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          )
                                                        ]
                                                      : [
                                                          _vm._l(
                                                            _vm.pageNumberListTask(),
                                                            function(n, index) {
                                                              return n >=
                                                                Number(
                                                                  _vm
                                                                    .serverParams
                                                                    .page
                                                                ) -
                                                                  (_vm.pageCompareTask -
                                                                    1) &&
                                                                n <=
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) +
                                                                    (_vm.pageCompareTask -
                                                                      1)
                                                                ? [
                                                                    n ==
                                                                    Number(
                                                                      _vm
                                                                        .serverParams
                                                                        .page
                                                                    )
                                                                      ? _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item active",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                            " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                        "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "li",
                                                                          {
                                                                            staticClass:
                                                                              "PagesClass page-item",
                                                                            attrs: {
                                                                              title:
                                                                                "Page " +
                                                                                n,
                                                                              id:
                                                                                "pageNumber" +
                                                                                n
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.onPerticularPageClickTask(
                                                                                  n
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                staticClass:
                                                                                  "page-link",
                                                                                attrs: {
                                                                                  href:
                                                                                    "javascript:void(0)"
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                            " +
                                                                                    _vm._s(
                                                                                      n
                                                                                    ) +
                                                                                    "\n                                                        "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                  ]
                                                                : _vm._e()
                                                            }
                                                          )
                                                        ]
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "page-item NextPage",
                                                  attrs: { title: "Next Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  Number(
                                                                    _vm
                                                                      .serverParams
                                                                      .page
                                                                  ) + 1
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-angle-right"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "li",
                                                {
                                                  staticClass: "LastPage",
                                                  attrs: { title: "Last Page" }
                                                },
                                                [
                                                  Number(
                                                    _vm.serverParams.page
                                                  ) == _vm.pageNumberListTask()
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "page-link",
                                                            attrs: {
                                                              href:
                                                                "javascript:void(0)",
                                                              tabindex: "-1"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.onPerticularPageClickTask(
                                                                  _vm.pageNumberListTask()
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.pageNumberListTask()
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "pageJumpLabel" },
                                            [_vm._v("Page : ")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.jumpToPageTask,
                                                expression: "jumpToPageTask"
                                              }
                                            ],
                                            staticClass:
                                              "form-control form-control-sm",
                                            attrs: {
                                              type: "text",
                                              name: "jumpToPageTask",
                                              id: "jumpToPageTask",
                                              placeholder: "Page"
                                            },
                                            domProps: {
                                              value: _vm.jumpToPageTask
                                            },
                                            on: {
                                              keyup: function($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                ) {
                                                  return null
                                                }
                                                return _vm.jumpToPageInTask.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.jumpToPageTask =
                                                  $event.target.value
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            }
                          },
                          _vm._l(_vm.rows, function(row, key) {
                            return {
                              key: "table-row",
                              fn: function(props) {
                                return [
                                  _c("div", { key: key }, [
                                    props.column.field == "action"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn edit-btn-vvg waves-effect",
                                                attrs: {
                                                  title: "Edit Customer",
                                                  to: {
                                                    name: "UpdateCustomer",
                                                    params: { id: props.row.id }
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-pencil",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn edit-btn-vvg waves-effect",
                                                attrs: {
                                                  title:
                                                    "List Customer Inventory",
                                                  to: {
                                                    name:
                                                      "ListCustomerInventory",
                                                    params: {
                                                      custId: props.row.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-list"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn edit-btn-vvg waves-effect",
                                                attrs: {
                                                  title: "Add Member",
                                                  to: {
                                                    name: "ListMember",
                                                    params: {
                                                      custId: props.row.id
                                                    }
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fa fa-user"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            props.row.is_active
                                              ? [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn edit-btn-vvg waves-effect fa fa-trash",
                                                      attrs: {
                                                        title: "Make Inactive"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.activeInactiveCustomer(
                                                            props.row.id,
                                                            "inactive"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-eye-slash",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn edit-btn-vvg waves-effect fa fa-trash",
                                                      attrs: {
                                                        title: "Make Active"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.activeInactiveCustomer(
                                                            props.row.id,
                                                            "active"
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-eye",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ],
                                            _vm._v(" "),
                                            props.row
                                              .linked_form_email_manager_count ==
                                              0 && props.row.is_active == 1
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn edit-btn-vvg waves-effect",
                                                    attrs: {
                                                      title: "Add Notification"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.addNotification(
                                                          props.row.id,
                                                          props.row
                                                            .customer_name
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-bell",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          2
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              props.formattedRow[
                                                props.column.field
                                              ]
                                            )
                                          )
                                        ])
                                  ])
                                ]
                              }
                            }
                          }),
                          {
                            key: "selected-row-actions",
                            fn: function(computed) {
                              return _c("div", {}, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(computed.selectedRows) +
                                    "\n                        "
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success my-1 ms-2",
                                    attrs: { id: "sendAppUpdates" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.sendAppUpdates.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Send App Updates(" +
                                        _vm._s(_vm.selectedRows) +
                                        ")"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success my-1 ms-2",
                                    attrs: { id: "activeInactiveCustomer" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.activeInactiveCustomer(
                                          0,
                                          "active"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Active Customer(" +
                                        _vm._s(_vm.selectedRows) +
                                        ")"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success my-1 ms-2",
                                    attrs: { id: "activeInactiveCustomer" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.activeInactiveCustomer(
                                          0,
                                          "inactive"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Inactive Customer(" +
                                        _vm._s(_vm.selectedRows) +
                                        ")"
                                    )
                                  ]
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("app-footer")
        ],
        1
      )
    : _c("div", [_c("no-permission")], 1)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Status: ")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a51fa66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a51fa66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/ListCustomer.vue
// module id = null
// module chunks = 